export default {"src":"/_next/static/media/manac.6d7cbd6e.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};